// extracted by mini-css-extract-plugin
export default {"switchContainer":"SwitchContainer_switchContainer__VRR+u","switch":"SwitchContainer_switch__f0Nnz","slider":"SwitchContainer_slider__MrSVY","round":"SwitchContainer_round__WOktC"};